import { toast, pauseOnVisibilityChange } from 'react-toastify';

const TOAST_POSITION = 'top-right';
const TOAST_AUTO_CLOSE = 5000;
const TOAST_PROGRESS_BAR = false;
const TOAST_NEWSET_ON_TOP = false;
const options = {
  position: TOAST_POSITION,
  autoClose: TOAST_AUTO_CLOSE,
  hideProgressBar: TOAST_PROGRESS_BAR,
  newestOnTop: TOAST_NEWSET_ON_TOP,
  closeOnClick: true,
  rtl: false,
  pauseOnVisibilityChange,
  pauseOnHover: true,
};
const DEFAULT_MSG = '';

export const toastSuccess = msg => toast.success(msg || DEFAULT_MSG, options);
export const toastError = msg => toast.error(msg || DEFAULT_MSG, options);
export const toastWarning = (msg, toastOption) => toast.warning(msg || DEFAULT_MSG,
  toastOption ? ({ ...options, ...toastOption }) : options);
export const toastInfo = msg => toast.info(msg || DEFAULT_MSG, options);
